import { providers } from '../../providers';
import { wavespeed } from '../wavespeed/index';
import type { TersaSpeechModel } from '../types';

// 系数
const COST_FACTOR = 2;

export const murekaModels: Record<string, TersaSpeechModel> = {
  'mureka-v9.5-prompt-to-song': {
    chef: providers.mureka,
    labelI18n: {
      en: 'Mureka V9.5 Prompt-to-Song',
      zh: 'Mureka V9.5 Prompt-to-Song',
    },
    providers: [
      {
        ...providers.mureka,
        model: wavespeed.speech('mureka-v9.5-prompt-to-song'),
        getCost: () => {
          return 0.75 * COST_FACTOR;
        },
      },
    ],
    voices: [],
    precheck: ['prompt'],
    supportsInput: ['t2m'],
    priceIndicator: 'lowest',
    price: 'Dynamic',
  },
  'mureka-v9.5-generate-song': {
    lyricsLabel: 'audio.lyrics',
    chef: providers.mureka,
    labelI18n: {
      en: 'Mureka V9.5 SONG',
      zh: 'Mureka V9.5',
    },
    providers: [
      {
        ...providers.mureka,
        model: wavespeed.speech('mureka-v9.5-generate-song'),
        getCost: () => {
          return 0.225 * COST_FACTOR;
        },
      },
    ],
    voices: ['lyrics'],
    precheck: ['lyrics'],
    supportsInput: ['t2m'],
    priceIndicator: 'lowest',
    price: 'Dynamic',
  },
  'mureka-v9.5-generate-bgm': {
    chef: providers.mureka,
    labelI18n: {
      en: 'Mureka V9.5 BGM',
      zh: 'Mureka V9.5',
    },
    providers: [
      {
        ...providers.mureka,
        model: wavespeed.speech('mureka-v9.5-generate-bgm'),
        getCost: () => {
          return 0.225 * COST_FACTOR;
        },
      },
    ],
    voices: [],
    precheck: ['prompt'],
    supportsInput: ['t2m'],
    priceIndicator: 'lowest',
    price: 'Dynamic',
  },
};